import { Router } from '@angular/router';
import { Component } from '@angular/core';
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { AuthService } from '../../services/auth/auth.service';
import { RootService } from 'src/app/services/root/root.service';
import { DialogComponent } from '../dialog/dialog.component';


@Component({
  selector: 'app-main-nav',
  templateUrl: './main-nav.component.html',
  styleUrls: ['./main-nav.component.scss']
})
export class MainNavComponent {
  toggle = false;
  mode = "over";
  session: any;
  userSession = JSON.parse(sessionStorage.getItem('session'));
  role = JSON.parse(sessionStorage.getItem('session'));
  constructor(
    private _authService: AuthService,
    private _router: Router,
    private rootService: RootService,
    private dialog: MatDialog) { }

  ngOnInit() {
    this.session = this._authService.loggedIn();
    console.log(this.userSession)
  }

  get isVendedor(): boolean {
    return this.role?.dsSesion?.ttsesion?.[0]?.tipo?.trim()?.toLowerCase() === 'vendedor';
  }

  logout() {
    this._authService.logout();
    window.location.reload();
    this._router.navigate(['/home']);
  }

  toggler() {
    if (this.toggle) {
      this.toggle = false;
    }
    else {
      this.toggle = true;
    }
  }

  openDialog() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    this.dialog.open(DialogComponent, dialogConfig);
  }
}
